export * from './normalizr';

/**
 * @enum {string}
 * @readonly
 */
export const ClientType = {
  IOS_MOBILE: '100',
  IOS_TABLET: '101',
  ANDROID_MOBILE: '102',
  ANDROID_TABLET: '103',
  DESKTOP: '104',
  SAMSUNG: '105',
  FIRE: '106',
  ANDROID_TV: '107',
  APPLE_TV: '108',
  ROKU: '109',
  TV: '110',
};

export const VERSION_MW_1 = 'v1';

export const FORGE_ROCK_PROVIDER = 'forgerock';
